import { CategoryState } from "@/config/store/category/type";

export const state: CategoryState = {
  categoryTree: undefined,
  rootCategories:null,
  activeCategory: null,
  page : null,
  rootCategory: null,
};